import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('profileListingSection', {
    id: {
        title: 'ID',
        type: 'string',
        hidden: true
    }
});
var validator = z.object({
    id: z.string()
}).partial();
schema.profileListingSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=profileListingSection.js.map